/* PDP interactivity: variant selection, quantity, add-to-cart, sticky bar,
   gallery carousel, zoom modal, analytics.
   Prices come from server-rendered money strings (data-pdp-prices), already in
   the active presentment currency (Shopify Markets). Bundle savings are real
   Shopify Automatic Discounts, applied + shown at cart/checkout — no client math. */
(function () {
  "use strict";
  var root = document.querySelector("[data-pdp]");
  if (!root) return;

  function $(s, r) { return (r || root).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }

  // ---- data ----
  var variants = JSON.parse($("[data-pdp-variants]").textContent);
  var options = JSON.parse($("[data-pdp-options]").textContent);
  var pricesEl = $("[data-pdp-prices]");
  var PRICES = pricesEl ? JSON.parse(pricesEl.textContent) : {};
  function priceStr(v) { var p = v && PRICES[v.id]; return p ? p.price : ""; }
  function compareStr(v) { var p = v && PRICES[v.id]; return p ? p.compare : ""; }
  // line total for a given quantity (server-rendered per tier → presentment-currency correct)
  function totalStr(v, q) { var p = v && PRICES[v.id]; return (p && p.totals && p.totals[q]) ? p.totals[q] : priceStr(v); }
  function compareTotalStr(v, q) { var p = v && PRICES[v.id]; return (p && p.compare_totals && p.compare_totals[q]) ? p.compare_totals[q] : compareStr(v); }

  function versionBlurb(value) {
    if (/baselit|dura|standard/i.test(value)) return "Most versatile";
    if (/xeno|premium/i.test(value)) return "For serious collectors";
    return null;
  }

  // ---- state ----
  var selected = {};
  options.forEach(function (o) { selected[o.name] = o.selected_value; });
  var _qd = $("[data-qty-default]"); var qty = _qd ? +_qd.getAttribute("data-qty") : 1;

  function optionNames() { return options.map(function (o) { return o.name; }); }
  function findVariant(sel) {
    var names = optionNames();
    return variants.filter(function (v) {
      return names.every(function (n, i) { return v.options[i] === sel[n]; });
    })[0];
  }
  function currentVariant() { return findVariant(selected) || variants[0]; }

  var stockEl = $("[data-stock-line]");
  var stockDefault = stockEl ? stockEl.textContent : "";

  function render() {
    var v = currentVariant();
    var rawPrice = v ? v.price : 0;
    var rawCompare = (v && v.compare_at_price) ? v.compare_at_price : 0;
    var onSale = rawCompare > rawPrice;
    var available = v ? v.available : false;

    // header price
    var mainPrice = $("[data-pdp-price]");
    if (mainPrice) mainPrice.textContent = totalStr(v, qty);
    var packNow = parseFloat(String(totalStr(v, qty)).replace(/[^0-9.]/g, "")) || 0;
    var packCmp = parseFloat(String(compareTotalStr(v, qty)).replace(/[^0-9.]/g, "")) || 0;
    var packSale = packCmp > packNow;
    var cmp = $("[data-pdp-compare]");
    if (cmp) {
      cmp.classList.toggle("hidden", !packSale);
      cmp.textContent = compareTotalStr(v, qty);
    }
    var sav = $("[data-pdp-save]");
    if (sav) {
      sav.classList.toggle("hidden", !packSale);
      if (packSale) sav.textContent = "Save " + Math.round((packCmp - packNow) / packCmp * 100) + "%";
    }

    // option buttons: price + availability + blurb
    $all("[data-option-btn]").forEach(function (btn) {
      var name = btn.getAttribute("data-option-name");
      var value = btn.getAttribute("data-option-value");
      var isSel = selected[name] === value;
      var probe = Object.assign({}, selected); probe[name] = value;
      var pv = findVariant(probe);
      var pAvail = pv ? pv.available : false;

      btn.classList.toggle("border-(--color-blue)", isSel);
      btn.classList.toggle("bg-(--color-blue)/15", isSel);
      btn.classList.toggle("ring-2", isSel);
      btn.classList.toggle("ring-(--color-blue)/40", isSel);
      btn.classList.toggle("border-(--color-hairline)", !isSel);
      btn.classList.toggle("bg-(--color-ink)", !isSel);
      btn.classList.toggle("opacity-40", !pAvail && !isSel);
      btn.classList.toggle("cursor-not-allowed", !pAvail && !isSel);
      btn.disabled = !pAvail && !isSel;

      var blurbEl = btn.querySelector("[data-version-blurb]");
      var blurb = versionBlurb(value);
      if (blurbEl) { if (blurb) { blurbEl.textContent = blurb; blurbEl.hidden = false; } else { blurbEl.hidden = true; } }

      var priceEl = btn.querySelector("[data-option-price]");
      if (priceEl && pv) {
        var pOnSale = (pv.compare_at_price || 0) > pv.price;
        priceEl.innerHTML =
          '<span class="font-mono text-[12px] tabular-nums text-(--color-bone)">' + priceStr(pv) + '</span>' +
          (pOnSale ? '<span class="font-mono text-[10px] tabular-nums text-(--color-muted) line-through">' + compareStr(pv) + '</span>' : "");
      }
      var soldEl = btn.querySelector("[data-option-soldout]");
      if (soldEl) soldEl.hidden = pAvail;
    });

    // current value labels
    $all("[data-option-current]").forEach(function (el) {
      var n = el.getAttribute("data-option-current");
      el.textContent = selected[n];
    });

    // qty tiers selected state (quantity only — discount is applied by Shopify)
    $all("[data-qty]").forEach(function (b) {
      var q = +b.getAttribute("data-qty");
      var isSel = q === qty;
      b.classList.toggle("border-(--color-blue)", isSel);
      b.classList.toggle("ring-2", isSel);
      b.classList.toggle("ring-(--color-blue)/40", isSel);
      b.classList.toggle("border-(--color-hairline)", !isSel);
      var top = b.querySelector("[data-qty-top]");
      var body = b.querySelector("[data-qty-body]");
      if (top) { top.classList.toggle("bg-(--color-blue)/30", isSel); top.classList.toggle("text-(--color-bone)", isSel); top.classList.toggle("bg-(--color-ink)", !isSel); top.classList.toggle("text-(--color-bone-soft)", !isSel); }
      if (body) { body.classList.toggle("bg-(--color-blue)", isSel); body.classList.toggle("text-white", isSel); body.classList.toggle("bg-(--color-ink-2)", !isSel); body.classList.toggle("text-(--color-bone)", !isSel); }
    });

    var bpick = $("[data-bundle-picker]");
    if (bpick) {
      var showPick = qty >= 2;
      bpick.classList.toggle("hidden", !showPick);
      if (showPick) {
        var _slots = bpick.querySelectorAll("[data-slot-wrap]");
        for (var _i = 0; _i < _slots.length; _i++) _slots[_i].classList.toggle("hidden", (_i + 1) > qty);
        var _grid = bpick.querySelector("[data-bundle-grid]");
        if (_grid) _grid.style.gridTemplateColumns = "repeat(" + qty + ",minmax(0,1fr))";
        var _ttl = bpick.querySelector("[data-bundle-title]");
        if (_ttl) _ttl.textContent = "Build your " + qty + "-pack — pick your sabers";
      }
    }

    // stock line
    if (stockEl) {
      if (!available) stockEl.textContent = "Out of stock";
      else if (v && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 10) stockEl.textContent = "Only " + v.inventory_quantity + " left · ships in 48h";
      else stockEl.textContent = stockDefault;
    }

    // CTA — show unit price (totals + bundle savings appear in cart/checkout)
    var extra = $("[data-add-extra]");
    var label = $("[data-add-label]");
    $all("[data-pdp-add]").forEach(function (b) { b.disabled = !available; });
    if (label) label.textContent = available ? "Add to cart" : "Sold out";
    if (extra) extra.innerHTML = available ? '<span class="opacity-50">—</span>' + (onSale ? '<span class="tabular-nums line-through opacity-55 mr-1.5">' + compareTotalStr(v, qty) + '</span>' : '') + '<span class="tabular-nums nb-now">' + totalStr(v, qty) + '</span>' : "";

    // sticky bar
    var sp = $("[data-sticky-price]");
    if (sp) sp.innerHTML = (onSale ? '<span class="font-mono text-[12px] tabular-nums text-(--color-muted) line-through">' + compareTotalStr(v, qty) + '</span>' : '') + '<span class="font-display text-[15px] tabular-nums text-(--color-blue) md:text-[16px] nb-now">' + totalStr(v, qty) + '</span>';
    var sQty = $("[data-sticky-qty]"); if (sQty) sQty.textContent = "Qty " + qty;
    var sVar = $("[data-sticky-variant]");
    if (sVar) { if (v && v.title && v.title !== "Default Title") { sVar.textContent = v.title; sVar.hidden = false; } else sVar.hidden = true; }
  }

  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available) return;
    var addBtns = $all("[data-pdp-add]");
    addBtns.forEach(function (b) { b.disabled = true; });
    var lbl = $("[data-add-label]"); if (lbl) lbl.textContent = "Adding\u2026";
    var extra = $("[data-add-extra]"); if (extra) extra.innerHTML = '<span class="ml-2 inline-block size-3.5 animate-spin rounded-full border-2 border-current border-t-transparent align-[-2px]"></span>';
    var finish = function () { render(); };
    var items, _pick = $("[data-bundle-picker]");
    if ((qty === 2 || qty === 3) && _pick && !_pick.classList.contains("hidden")) {
      items = Array.prototype.slice.call(_pick.querySelectorAll("[data-slot]")).slice(0, qty).map(function (s) { return { id: +s.value, quantity: 1, properties: { _kind: "saber" } }; });
    } else {
      items = [{ id: v.id, quantity: qty, properties: { _kind: "saber" } }];
    }
    var p = window.NovaCart.add(items, true);
    if (p && typeof p.then === "function") p.then(finish, finish); else setTimeout(finish, 1000);
    try {
      if (window.posthog) window.posthog.capture("add_to_cart", { handle: root.getAttribute("data-product-handle"), qty: qty, price: v.price / 100 });
    } catch (e) {}
  }

  function init() {
    $all("[data-option-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        selected[btn.getAttribute("data-option-name")] = btn.getAttribute("data-option-value");
        render();
      });
    });
    $all("[data-qty]").forEach(function (b) { b.addEventListener("click", function () { qty = +b.getAttribute("data-qty"); render(); }); });
    $all("[data-slot]").forEach(function (s) {
      s.addEventListener("change", function () {
        var opt = s.options[s.selectedIndex], img = s.parentNode.querySelector("[data-slot-img]");
        if (img && opt && opt.getAttribute("data-img")) img.src = opt.getAttribute("data-img");
      });
    });
    $all("[data-pdp-add]").forEach(function (b) { b.addEventListener("click", addToCart); });
    $all("[data-scroll-to]").forEach(function (b) { b.addEventListener("click", function () { var t = document.getElementById(b.getAttribute("data-scroll-to")); if (t) t.scrollIntoView({ behavior: "smooth", block: "start" }); }); });

    // gallery thumbs (mobile)
    var swiper = $("[data-gallery-swiper]");
    $all("[data-gallery-thumb]").forEach(function (th) {
      th.addEventListener("click", function () {
        var i = +th.getAttribute("data-gallery-thumb");
        if (swiper) swiper.scrollTo({ left: i * swiper.clientWidth, behavior: "smooth" });
      });
    });
    if (swiper) {
      swiper.addEventListener("scroll", function () {
        var i = Math.round(swiper.scrollLeft / swiper.clientWidth);
        $all("[data-gallery-thumb]").forEach(function (th) {
          var sel = +th.getAttribute("data-gallery-thumb") === i;
          th.classList.toggle("border-(--color-blue)", sel);
          th.classList.toggle("opacity-100", sel);
          th.classList.toggle("border-(--color-hairline)", !sel);
          th.classList.toggle("opacity-55", !sel);
        });
      });
    }

    // zoom modal
    var modal = $("[data-zoom-modal]");
    var zimg = $("[data-zoom-img]");
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-zoom-open]");
      if (opener && modal) { zimg.src = opener.getAttribute("data-zoom-open"); modal.hidden = false; document.body.style.overflow = "hidden"; return; }
      if (e.target.closest("[data-zoom-close]") || e.target === modal) { if (modal) { modal.hidden = true; document.body.style.overflow = ""; } }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ""; } });

    // sticky bar visibility
    var mainCta = root.querySelector(".rounded-lg [data-pdp-add]");
    var sticky = $("[data-sticky-atc]");
    if (mainCta && sticky && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.bottom < 0;
        sticky.classList.toggle("opacity-0", !past);
        sticky.classList.toggle("translate-y-6", !past);
        sticky.classList.toggle("pointer-events-none", !past);
        sticky.classList.toggle("opacity-100", past);
        sticky.classList.toggle("translate-y-0", past);
      }, { threshold: 0 });
      io.observe(mainCta);
    }

    // analytics: product view
    try {
      if (window.posthog) window.posthog.capture("product_view", { handle: root.getAttribute("data-product-handle") });
    } catch (e) {}

    render();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();









